import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "21",
  viewBox: "0 0 20 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M12.3567 13.2434C11.7316 13.8683 10.8839 14.2193 10 14.2193C9.11612 14.2193 8.26843 13.8683 7.64333 13.2434M7.5 10.0534H7.50833M12.5 10.0534H12.5083M17.5 10.8867C17.5 11.8716 17.306 12.8469 16.9291 13.7568C16.5522 14.6668 15.9997 15.4936 15.3033 16.19C14.6069 16.8865 13.7801 17.4389 12.8701 17.8158C11.9602 18.1927 10.9849 18.3867 10 18.3867C9.01509 18.3867 8.03982 18.1927 7.12987 17.8158C6.21993 17.4389 5.39314 16.8865 4.6967 16.19C4.00026 15.4936 3.44781 14.6668 3.0709 13.7568C2.69399 12.8469 2.5 11.8716 2.5 10.8867C2.5 8.89759 3.29018 6.98994 4.6967 5.58342C6.10322 4.1769 8.01088 3.38672 10 3.38672C11.9891 3.38672 13.8968 4.1769 15.3033 5.58342C16.7098 6.98994 17.5 8.89759 17.5 10.8867Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M10.0007 3.38672C10.834 3.38672 12.5377 4.83794 11.6673 6.30339C10.7969 7.76883 8.76917 7.29458 8.33398 6.31761",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }